import FingerprintJS from '@fingerprintjs/fingerprintjs-pro';

export const initFingerPrint = async () => {
  // Initialize an agent at application startup.
  const fpHandler = await FingerprintJS.load({ apiKey: process.env.REACT_APP_FINGER_PRINT_API_KEY || '' });
  const fpData = await fpHandler.get();
  const { visitorId } = fpData;
  return visitorId;
};
